<template>
<div class="shopping-cart payment vld-parent" ref="CP_main_ref">
    <loading :active.sync="pageLoader" color='#0dc07f'></loading>
		<div class="container-fluid">
			<div class="row paymentPage">

				<div class="col-md-8">
					<h2 class="textGreen">Payment Selection</h2>
					<form @submit.prevent="submit_payment()">
						<div class="payment-group">
							<div class="row pgTop vld-parent" ref="CPCartinfo_ref">
								<div class="col-sm-7 col-lg-8">
									<div class="radioCommon">
										<input type="radio" id="test1" name="radio-group" value="Stripe" v-model="payment_gateway">
										<label for="test1">Credit Card</label>
									</div>
									<p>Safe money transfer using your bank account. Visa, Maestro, Discover,
									American Express</p>
								</div>
								<div class="col-sm-5 col-lg-4 paymentIcon">
									<a href="javascript:void(0);"><img src="images/payment-icon01.png"></a>
									<a href="javascript:void(0);"><img src="images/payment-icon02.png"></a>
									<a href="javascript:void(0);"><img src="images/payment-icon03.png"></a>
								</div>

								<div class="col-md-12 formSection" v-if="payment_gateway=='Stripe'">
									<div class="form-group">
									    <label class="haveToolTip">Card Number
									        <span class="icons help">
									            <i :class="cardBrandClass" v-if="cardBrandClass"></i>
									            <img v-else src="images/card.png" class="img-fluid" alt="">
									        </span>
									    </label>
									    <input type="text" name="card_number" class="form-control" v-model="PaymentCart.card_number" v-cardformat:formatCardNumber placeholder="#### #### #### ####"  v-validate="'required'" data-vv-as="card numbere" >
                                        <p v-if="verrors.has('card_number')||cardErrors.cardNumber" class="errormsg">
                                            {{ typeof cardErrors.cardNumber  == 'undefined' ? verrors.first('card_number') : cardErrors.cardNumber }}
                                        </p>
									</div>

                                <div class="form-group">
                                    <div>
                                        <label>Name on Card</label>
                                        <input type="text" name="name_on_Card" class="form-control" v-model="PaymentCart.name_on_Card" ref="cardNameInput"  v-validate="'required'" data-vv-as="name on Card">
                                        <p v-if="verrors.has('name_on_Card')" class="errormsg">{{ verrors.first('name_on_Card')  }}</p>
                                    </div>
                                    <div>
                                        <label>Expiration Date</label>
                                        <input type="text" placeholder="MM/YY" name="exp_date" class="datepicker form-control"
                                            v-model="PaymentCart.exp_date" v-cardformat:formatCardExpiry  v-validate="'required'" data-vv-as="expiry date">
                                        <p v-if="verrors.has('exp_date')||cardErrors.cardExpiry" class="errormsg">
                                            {{ typeof cardErrors.cardExpiry  == 'undefined' ? verrors.first('exp_date') : cardErrors.cardExpiry }}
                                        </p>
                                    </div>
                                    <div>
                                        <label class="haveToolTip">CVV Code <span class="icons help" v-tooltip="'It\'s the 3-digit number on the back of the card'"><img src="images/help.png" class="img-fluid" alt=""></span></label>
                                        <input type="password" name="cvv" class="form-control" v-model="PaymentCart.cvv" v-cardformat:formatCardCVC ref="cardCvvInput"  v-validate="'required'" data-vv-as="CVV">

                                        <p v-if="verrors.has('cvv')||cardErrors.cardCvc" class="errormsg">
                                            {{ typeof cardErrors.cardCvc  == 'undefined' ? verrors.first('cvv') : cardErrors.cardCvc }}
                                        </p>
                                    </div>
                                </div>

									<div class="form-group change-address">
										<h4>Billing address</h4>
										<p v-if="PaymentCart">

											{{ PaymentCart.street +' '}} {{PaymentCart.apartment || ""}}<br>
											 {{ PaymentCart.city }}, {{ PaymentCart.state }}<br>
											{{ PaymentCart.zip_code }}

										</p>
										<a href="javascript:void(0);" @click="address_pop('o')" class="changeAddress">Change  Address</a>

                                    <p v-if="verrors.has('street')" class="errormsg">{{ verrors.first('street') }}</p>
                                    <p v-if="verrors.has('state')" class="errormsg">{{ verrors.first('state') }}</p>
                                    <p v-if="verrors.has('city')" class="errormsg">{{ verrors.first('city') }}</p>
                                    <p v-if="verrors.has('zip_code')" class="errormsg">{{ verrors.first('zip_code') }}</p>

									</div>
								</div>
							</div>
						</div>
						<div class="row">
						    <div class="col-md-12">
						      <!--   <div class="paypalGroup">
						            <div class="paypaltop">
						                <div class="radioCommon">
						                    <input type="radio" id="test2" name="radio-group" value="Crypto" v-model="payment_gateway">
						                    <label for="test2">Crypto Currency</label>
						                </div>
						                <span class="paypalIcon"><img src="images/crypto.png"></span>
						            </div>
						            <p>You will be redirected to Coingate website to complete your purchase securely.</p>
						        </div>  -->
						        <div class="buttonGroup paybtnGroup">
						            <div>
                                        <a href="javascript:void(0);"
						                    @click="$router.push({name: 'Checkout',params: {coupondata: applied_coupon}})">Back to Shipping Info</a>
                                            </div>
						            <div><button type="submit" class="payBtn">Pay Now</button></div>
						        </div>
						    </div>
						</div>
					</form>
				</div>
				<div class="col-md-4">
					<div class="order-Summery vld-parent" ref="CPOrdersummery_ref">
						<div class="titleTop smTitletop">
							<span><h3>Wevisu Shopping Cart</h3></span><span v-if="projectCart && projectCart.Project_tans">({{projectCart.Project_tans.length}} Items)</span>
						</div>
						<div class="contemBottom "  v-if="projectCart && projectCart.Project_tans">

							<div class="shipping-list">
								<div class="row slGroup" v-for="(item, index) in projectCart.Project_tans" :key="'cp'+index">
									<div class="col-5"><figure><img :src="set_image(item.photo)" class="img-fluid"></figure></div>
									<div class="col-7">
										<h3>{{item.name}}<span v-if="item.is_sample==1">(Sample)</span></h3>
                                        <p v-if="item.sku"><span>SKU:</span><span>{{item.sku}}</span></p>
										<ul class="list-unstyled">
											<li v-if="item.width_size"><span>Width:</span><span>{{item.width_size}}</span></li>
                                            <li v-if="item.length_size"><span>Length:</span><span>{{item.length_size}}</span></li>
                                            <li v-if="item.height_size"><span>{{ item.product_cat_unit=='Box'?'Length': 'Height'}}:</span><span>{{item.height_size}}</span></li>
										</ul>
										<p><span>Qty:</span><span>{{item.qty}}</span></p>
										<p><span>Price:</span><span>{{item.product_total_price|toCurrency}}</span></p>
									</div>
								</div>
							</div>

							<div class="itemdetail-group">
								<ul class="list-unstyled">
									<li><span>Subtotal</span><span>{{ projectCart.sub_total|toCurrency }}</span></li>
									<li v-if="user && user.type=='User' && applied_coupon &&  applied_coupon.coupon"><span>Discount- {{ applied_coupon.coupon }} ({{ applied_coupon.discount }}%)</span><span>- {{ discount_amt|toCurrency }}</span></li>

									<li><span>Shipping</span><span>{{ projectCart? projectCart.shipping_price : 0 |toCurrency}}</span></li>
                                    <li><span>Tax</span><span>{{ Number(projectCart.sub_total  * Setting.ORDER_PROFIT / 100) |toCurrency}}</span></li>
								</ul>
							</div>

							<div class="total">
								<span>Total</span><span>{{calculate_cart_total(projectCart.sub_total,projectCart.shipping_price) }} </span>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>


        <div class="modal fade" id="cartAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <form class="modal-content" @submit.prevent="updateShipping()">
                    <div class="modal-header">
                        <h2 class="modal-title h4" id="exampleModalLabel">Billing Address</h2>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body py-5 vld-parent" ref="CPCart_cng_ref">
                                        <label class="inputWrpr"
			        :class="{ 'error': verrors.has('address') ,'haveValue': PaymentCart.street }">
			          <vue-google-autocomplete
                        id="billadd"
                        ref="billAddress"
                        classname="form-control"
                        placeholder="Start typing"
                        v-on:placechanged="getAddressData"
                        types=""
                        >
                        {{ bill_address.address }}
                        </vue-google-autocomplete>
			        <span class="label">Address</span>
                    <p v-if="verrors.has('address')" class="errormsg">{{ verrors.first('address') }}</p>
			    </label>
                        <label class="inputWrpr"
                            :class="{ 'error': verrors.has('street') ,'haveValue': bill_address.street }">
                            <input type="text" v-model="bill_address.street" class="form-control"  v-validate="'required'" data-vv-as="street" name="street">
                            <span class="label">Street</span>
                            <p v-if="verrors.has('street')" class="errormsg">{{ verrors.first('street') }} </p>
                        </label>
                        <label class="inputWrpr"
                            :class="{ 'error': verrors.has('city') ,'haveValue': bill_address.city }">
                            <input ype="text" v-model="bill_address.city" class="form-control"  v-validate="'required'" data-vv-as="city" name="city">
                            <span class="label">City</span>
                            <p v-if="verrors.has('city')" class="errormsg">{{ verrors.first('city') }} </p>
                        </label>
                        <label class="inputWrpr"
                            :class="{ 'error': verrors.has('state') ,'haveValue': bill_address.state }">
                            <input type="text" v-model="bill_address.state" class="form-control"  v-validate="'required'" data-vv-as="state" name="state">
                            <span class="label">State</span>
                            <p v-if="verrors.has('state')" class="errormsg">{{ verrors.first('state') }} </p>
                        </label>
                        <label class="inputWrpr"
                            :class="{ 'error': verrors.has('zip_code') ,'haveValue': bill_address.zip_code }">
                            <input type="text" v-model="bill_address.zip_code" class="form-control" v-validate="'required|numeric'" data-vv-as="zip code" name="zip_code">
                            <span class="label">Zip Code</span>
                            <p v-if="verrors.has('zip_code')" class="errormsg">{{ verrors.first('zip_code') }}</p>
                        </label>
                        <label class="inputWrpr"
                            :class="{ 'error': verrors.has('apartment') ,'haveValue': bill_address.apartment }">
                            <input type="text" v-model="bill_address.apartment" class="form-control" v-validate="''" data-vv-as="Apartment" name="apartment">
                            <span class="label">Apartment</span>
                            <p v-if="verrors.has('apartment')" class="errormsg">{{ verrors.first('apartment') }} </p>
                        </label>

                    </div>
                    <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-secondary m-2" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary m-2">Change</button>
                    </div>
                </form>
            </div>
        </div>


	</div>

</template>

<script>
import Vue from 'vue';

import {
    mapGetters,
    mapActions
} from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
    props: ['applied_coupon', 'appliedShippingAddress', 'appliedShippingCharge'],
    name: "Header",
    data() {
        return {
            bill_address:{
                street:'',
                zip_code:'',
                state:'',
                city:'',
                address:'',
                apartment:'',
                address_lat:'',
                address_long:''
            },
            cardErrors: {},
            cardBrand: null,
            $cardFormat: Vue.prototype.$cardFormat,
            payment_gateway: 'Stripe',
            discount_amt: 0,
            stripeToken: null,
            stripeAPIToken: '',
            pageLoader: false,
        };
    },
        components: {
        VueGoogleAutocomplete
    },
    beforeDestroy() {
        this.pageLoader = false;
    },
    computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("auth", ["user"]),
        ...mapGetters("Checkout", ["UserShippingAddress", "Coupon", "ShippingCharge", "PaymentCart"]),
        ...mapGetters("cart", ["projectCart"]),
        ...mapGetters("Common", ["Setting"]),
        cardBrandClass() {
            return this.getBrandClass(this.cardBrand);
        }
    },
    watch: {
        Setting: {
            handler(items) {
                if (items)
                    this.stripeAPIToken = items.STRIPEPUBLICKEY
            },
            immediate: true,
            deep: true
        },
        'appliedShippingAddress': {
            handler(n) {
                if (n) {
                    this.PaymentCart.street = n.street
                    this.PaymentCart.city = n.city
                    this.PaymentCart.state = n.state
                    this.PaymentCart.zip_code = n.zip_code
                    this.PaymentCart.apartment = n.apartment

                    this.bill_address.address=''
                    this.bill_address.street = n.street
                    this.bill_address.city = n.city
                    this.bill_address.state = n.state
                    this.bill_address.zip_code = n.zip_code
                    this.bill_address.apartment = n.apartment

                }
            },
            deep: true,
            immediate: true,
        },
/*         'PaymentCart':{
            handler(n,o) {
                //console.log(n,o);
                //console.warn(this.appliedShippingAddress,n,o);
                 if (this.appliedShippingAddress && typeof (o) == 'undefined') {

                    this.PaymentCart.street = this.appliedShippingAddress.street
                    this.PaymentCart.city = this.appliedShippingAddress.city
                    this.PaymentCart.state = this.appliedShippingAddress.state
                    this.PaymentCart.zip_code = this.appliedShippingAddress.zip_code
                }
            },
            deep: true,
            immediate: true,
        }, */

        projectCart: {
            handler(crd) {
                if (crd && crd.Project_tans && crd.Project_tans.length === 0) {
                    Toast.fire({
                        icon: 'warning',
                        title: 'Please Add Products to Shopping Cart To Place Order.'
                    });
                    this.$router.push('/').catch({});
                }
            },
            deep: true,
            immediate: true,
        },
        'PaymentCart.card_number': function (val) {
            if (this.$cardFormat.validateCardNumber(val)) {
                this.$refs.cardNameInput.focus();
            }
        },
        'PaymentCart.exp_date': function (val) {
            if (this.$cardFormat.validateCardExpiry(val)) {
                this.$refs.cardCvvInput.focus();
            }
        }
    },
    async created() {
        if (!this.appliedShippingAddress) {
            Toast.fire({
                icon: 'success',
                title: 'Please Add your Shipping Address To Place Order.'
            });
            this.$router.push({name: 'Cart'}).catch(() => {});
            return false;
        }
        let ordersummeryloader = this.$loading.show({
            container: this.$refs.CPOrdersummery_ref
        });
        this.getCartData().then(() => {
                ordersummeryloader.hide()
            })
            .catch(err => {
                ordersummeryloader.hide()
            })

        let cartinfoloader = this.$loading.show({
            container: this.$refs.CPCartinfo_ref
        });
        this.getShippingAddressData({
                payment: 1
            }).then(() => {
                cartinfoloader.hide()
            })
            .catch(err => {
                Toast.fire({
                    icon: 'success',
                    title: 'Please Add your Shipping Address To Place Order.'
                });
                this.$router.push({name: 'Cart'}).catch(() => {});
            })
    },
    async mounted() {
        await this.includeStripe('js.stripe.com/v2/', function () {
            this.configureStripe();
        }.bind(this));
    },
    methods: {
        address_pop(s = '') {
            if (s=='save') {
                this.PaymentCart.address = this.bill_address.address;
                this.PaymentCart.street = this.bill_address.street;
                this.PaymentCart.state = this.bill_address.state;
                this.PaymentCart.city = this.bill_address.city;
                this.PaymentCart.zip_code = this.bill_address.zip_code;
                this.PaymentCart.apartment = this.bill_address.apartment
                this.bill_address.address_lat = this.bill_address.address_lat;
                this.bill_address.address_long = this.bill_address.address_long;
            }else if(s=='o'){
                $('#cartAddressModal').modal('show');
            }else {
                this.bill_address.address = ''
                this.bill_address.street = this.PaymentCart.street
                this.bill_address.city = this.PaymentCart.city
                this.bill_address.state = this.PaymentCart.state
                this.bill_address.zip_code = this.PaymentCart.zip_code
                this.bill_address.apartment = this.PaymentCart.apartment
            }
        },
        getAddressData(addressData, placeResultData, id) {
            if (addressData.postal_code) {
                this.bill_address.zip_code = addressData.postal_code
            }

            let address_components = placeResultData.address_components;
            const parseGoogleAddressComponents = this.parseGoogleResponse(address_components);

            this.bill_address.address = placeResultData.formatted_address;
            this.bill_address.street = (parseGoogleAddressComponents.nr?parseGoogleAddressComponents.nr +' ' :'') + parseGoogleAddressComponents.street;
            this.bill_address.state = parseGoogleAddressComponents.state;
            this.bill_address.city = parseGoogleAddressComponents.city;
            this.bill_address.zip_code = parseGoogleAddressComponents.zip;
            this.bill_address.address_lat = addressData.latitude
            this.bill_address.address_long = addressData.longitude
        },

        async includeStripe(URL, callback) {
            let documentTag = document,
                tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = 'https://' + URL;
            if (callback) {
                object.addEventListener('load', function (e) {
                    callback(null, e);
                }, false);
            }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },
        configureStripe() {
            Stripe.setPublishableKey(this.stripeAPIToken);
        },
        ...mapActions("cart", ["getCartData"]),
        ...mapActions("Checkout", ["getShippingAddressData", "UpdateShippingAddress"]),

        calculate_cart_total(cart_price = 0,ship=0) {
            
            let coupon_percent = 0
            let discount_price = 0
            if (this.applied_coupon && this.applied_coupon.discount && !isNaN(this.applied_coupon.discount)) {
                coupon_percent = Number(this.applied_coupon.discount)
            }
            discount_price = Number(cart_price * coupon_percent / 100)
            this.discount_amt = discount_price.toFixed(2)
            let totalp = Number(cart_price - discount_price);
           // let ship = this.appliedShippingCharge ? this.appliedShippingCharge.charge : 0
            let orderprofit= Number(cart_price  * this.Setting.ORDER_PROFIT / 100)
            ship=Number(ship);
            return Number(totalp + ship + orderprofit).toFixed(2);
        },
        prefill: function (ccNum) {
            this.details.card_number = ccNum;
            this.$cardFormat.setCardType({
                currentTarget: this.$refs.cardNumInput,
                value: ccNum
            });
        },
        getBrandClass: function (brand) {
            let icon = '';
            brand = brand || 'unknown';
            let cardBrandToClass = {
                'visa': 'fa fa-cc-visa',
                'mastercard': 'fa fa-cc-mastercard',
                'amex': 'fa fa-cc-amex',
                'discover': 'fa fa-cc-discover',
                'diners': 'fa fa-cc-diners-club',
                'jcb': 'fa fa-cc-jcb',
                'unknown': 'fa fa-credit-card',
            };
            if (cardBrandToClass[brand]) {
                icon = cardBrandToClass[brand];
            };
            return icon;
        },
        async updateShipping() {
           // this.$validator.validate().then(async (valid) => {
            //    if (valid) {
                    this.address_pop('save')
                    $('#cartAddressModal').modal('hide');
             //   }
           // })
        },
        async submit_payment() {
            if (this.payment_gateway == "Stripe") {
                await this.$validator.validate().then((valid) => {
                    if (valid) {
                        this.cardErrors = {};
                        if (!this.$cardFormat.validateCardNumber(this.PaymentCart.card_number) && this.PaymentCart.card_number) {
                            this.cardErrors.cardNumber = "Invalid Card Number.";
                        };
                        if (!this.$cardFormat.validateCardExpiry(this.PaymentCart.exp_date) && this.PaymentCart.exp_date) {
                            this.cardErrors.cardExpiry = "Invalid Expiration Date.";
                        };
                        if (!this.$cardFormat.validateCardCVC(this.PaymentCart.cvv) && this.PaymentCart.cvv) {
                            this.cardErrors.cardCvc = "Invalid CVC.";
                        };

                        if (Object.keys(this.cardErrors).length == 0) {
                            this.pageLoader = true
                            let exp = this.PaymentCart.exp_date.split('/');
                            Stripe.createToken({
                                number: this.PaymentCart.card_number,
                                cvc: this.PaymentCart.cvv,
                                exp_month: exp[0].trim(),
                                exp_year: exp[1].trim()
                            }, this.stripeResponseHandler);
                            return false;
                        }
                    }
                });
            } else {
                 this.pageLoader = true;
                 let fdata = {
                     payment_gateway: this.payment_gateway,
                     applied_coupon: this.applied_coupon,
                     appliedShippingAddress: this.appliedShippingAddress,
                     appliedShippingCharge: this.appliedShippingCharge
                 }
                 axios.post('/api/order', fdata)
                     .then(res => {
                         this.pageLoader = false;
                         console.log("====>",res.data.data);
                         if (res.data && res.data.data && res.data.data.Payment && res.data.data.Payment.payment_url) {
                             window.location.href = res.data.data.Payment.payment_url
                         } else {
                             this.$router.push({
                                 name: 'Thankyou',
                                 params: {
                                     order: res.data.data,
                                 }
                             });
                         }
                     })
                     .catch(err => {
                         this.pageLoader = false;
                     });
            }
        },

        async stripeResponseHandler(status, response) {
            if (response.error) {
                this.cardErrors = {};
                if (response.error.param == 'number') {
                    this.cardErrors.cardNumber = response.error.message;
                };
                if (response.error.param == 'exp_year') {
                    this.cardErrors.cardExpiry = response.error.message;
                };
                if (response.error.param == 'cvc') {
                    this.cardErrors.cardCvc = response.error.message;
                };
                if (typeof (response.error.param) === 'undefined' || (response.error.param != 'number' && response.error.param != 'exp_year' && response.error.param != 'cvc')) {
                    Toast.fire({
                        icon: 'warning',
                        title: response.error.message
                    });
                }
                this.pageLoader = false
            } else {
                this.stripeToken = response['id']
                let fdata = {
                    project:parseInt( localStorage.getItem('project'))||0,
                    stripeToken: response['id'],
                    PaymentCart: this.PaymentCart,
                    payment_gateway: this.payment_gateway,
                    applied_coupon: this.applied_coupon,
                    appliedShippingAddress: this.appliedShippingAddress,
                    appliedShippingCharge: this.appliedShippingCharge
                }

                axios.post('/api/order', fdata)
                    .then(res => {
                        this.pageLoader = false;
                        this.$router.push({
                            name: 'Thankyou',
                            params: {
                                order: res.data.data
                            }
                        });
                    })
                    .catch(err => {
                        this.pageLoader = false;
                    });
            }
        },

    },
};
</script>
<style scoped>
.errormsg {
    color: #e3342f !important;
    font-size: 12px !important;
}
</style>
